import React, { useState } from 'react';

import { rotuloEmpresa } from '../../lib/empresas';
import { nomeParaAgenda } from '../../lib/nomeContato';

// Copia "Pessoa - Empresa - Interesse - Produxia" para colar ao salvar o contato no
// WhatsApp. `compacto` é o ícone do card do Kanban; sem ele, botão com texto no modal.
function CopiarContato({ lead, company, compacto = false }) {
  const [copiado, setCopiado] = useState(false);
  const nome = nomeParaAgenda(lead, rotuloEmpresa(company));
  const copiar = async (e) => {
    e.stopPropagation();
    try { await navigator.clipboard.writeText(nome); }
    catch {
      // Navegador sem permissão de área de transferência: copia pelo jeito antigo.
      const t = document.createElement('textarea'); t.value = nome; document.body.appendChild(t);
      t.select(); document.execCommand('copy'); t.remove();
    }
    setCopiado(true); setTimeout(() => setCopiado(false), 1600);
  };
  const icone = copiado
    ? <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5" /></svg>
    : <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><rect x="8" y="8" width="12" height="12" rx="2.5" /><path d="M16 8V6a2 2 0 00-2-2H6a2 2 0 00-2 2v8a2 2 0 002 2h2" /></svg>;
  if (compacto) return <button type="button" onClick={copiar}
    title={copiado ? 'Copiado!' : `Copiar nome para salvar no WhatsApp: ${nome}`} aria-label="Copiar nome do contato"
    className={`flex items-center px-1.5 py-0.5 rounded-full t-caption-2 transition-colors ${copiado ? 'bg-green-100 text-green-700' : 'bg-black/[0.05] text-gray-500 hover:bg-black/[0.1] hover:text-gray-700'}`}>
    {icone}
  </button>;
  return <button type="button" onClick={copiar} title={nome}
    className={`inline-flex items-center gap-1 text-xs font-medium px-2 py-0.5 rounded-full transition-colors ${copiado ? 'bg-green-100 text-green-700' : 'bg-black/[0.05] text-gray-600 hover:bg-black/[0.1]'}`}>
    {icone} {copiado ? 'Copiado' : 'Copiar contato'}
  </button>;
}

export { CopiarContato };
